import React from "react";
import HistoricLineChart from "./HistoricLineChart";
import { parseState } from "src/lib/historyChart";

export default function FanStateGraph(props) {
  return (
    <HistoricLineChart
      title="Fan State Graph"
      subject="fan status"
      history={props.historicFanState}
      parse={parseState}
      kind="state"
      yLabel="State"
      startDate={props.startDate}
      endDate={props.endDate}
    />
  );
}
